package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import br.com.htms.inspeccaocampo.ui.HtmsBackdrop
import kotlinx.coroutines.launch

@Composable
fun SharedLoginScreen(
    onLoggedIn: () -> Unit,
    /** Quando true, o shell (Web) já desenha backdrop + coluna; não repete o fundo. */
    embeddedInShell: Boolean = false
) {
    var username by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var erro by remember { mutableStateOf<String?>(null) }
    var carregando by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    fun tentarLogin() {
        if (carregando) return
        val u = username.trim()
        val p = password
        if (u.isBlank() || p.isBlank()) {
            erro = "Informe usuário e senha."
            return
        }
        carregando = true
        erro = null
        scope.launch {
            val result = AuthApi.login(u, p)
            carregando = false
            result.onSuccess { onLoggedIn() }
                .onFailure { erro = it.message ?: "Falha no login" }
        }
    }

    val form: @Composable () -> Unit = {
        Column(
            modifier = Modifier
                .widthIn(max = 420.dp)
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            OutlinedTextField(
                value = username,
                onValueChange = {
                    username = it
                    erro = null
                },
                label = { Text("Usuário") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                enabled = !carregando,
                keyboardOptions = KeyboardOptions(
                    keyboardType = KeyboardType.Ascii,
                    imeAction = ImeAction.Next
                ),
                colors = FormFieldDefaults.textFieldColors()
            )
            OutlinedTextField(
                value = password,
                onValueChange = {
                    password = it
                    erro = null
                },
                label = { Text("Senha") },
                singleLine = true,
                modifier = Modifier.fillMaxWidth(),
                enabled = !carregando,
                visualTransformation = PasswordVisualTransformation(),
                keyboardOptions = KeyboardOptions(
                    keyboardType = KeyboardType.Password,
                    imeAction = ImeAction.Done
                ),
                keyboardActions = KeyboardActions(onDone = { tentarLogin() }),
                colors = FormFieldDefaults.textFieldColors()
            )
            if (erro != null) {
                Text(erro!!, color = MaterialTheme.colorScheme.error)
            }
            Spacer(Modifier.height(2.dp))
            Button(
                onClick = { tentarLogin() },
                enabled = !carregando,
                modifier = Modifier.fillMaxWidth()
            ) {
                if (carregando) {
                    CircularProgressIndicator(
                        modifier = Modifier.height(22.dp).padding(end = 8.dp),
                        strokeWidth = 2.dp,
                        color = Color.White
                    )
                    Text("Entrando...")
                } else {
                    Text("Entrar")
                }
            }
        }
    }

    if (embeddedInShell) {
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            form()
        }
        return
    }

    Box(modifier = Modifier.fillMaxSize()) {
        HtmsBackdrop(modifier = Modifier.fillMaxSize())
        Box(
            modifier = Modifier.fillMaxSize(),
            contentAlignment = Alignment.Center
        ) {
            form()
        }
    }
}
